import Axios from "axios";
import {
  collegeUserFFShowUrl,
  ffConfirmByCollegeUserUrl,
  cancelConfirmationUrl,
  cancelApplicationUrl,
  getCollegeUserWiseConfirmCandidateUrl,
  getIncourseData,
  getIncourseCandidatesList,
  getIncourseMarksList,
  submitIncoursebyCu,
  cancelIncourseSubmissionbyCu,
} from "../../api";
import {
  saveMsg,
  updateMsg,
  deleteMsg,
  failedMsg,
  sessionExpireMsg
} from "../../erpUtil";
import {
  UNSET_DATA_ENTRY_SCHEMA,
  SET_DATA_ENTRY_DETAILS,
  UNSET_DATA_ENTRY_DETAILS,
  SET_COLLEGE_USER_WISE_CANDIDATE,
  UNSET_COLLEGE_USER_WISE_CANDIDATE,
  GET_INCOURSE_DATA,
  UNSET_GET_INCOURSE_DATA,
  GET_INCOURSE_MARKS_LIST,
  GET_INCOURSE_CANDIDATES_LIST,
} from "../../mutation-types";
const state = {
  dataEntrySchema: {
    reg_no: null,
    current_privilege: null
  },
  data_entry_details: [],
  user_wise_candidate: [],
  incourse_data: [],
  incourse_candidates_list: {},
  incourse_marks_list: []
};
const getters = {
  getConfirmDataEntrySchema(state) {
    return state.dataEntrySchema;
  },
  getConfirmDataEntryDetails(state) {
    return state.data_entry_details;
  },
  getCollegeUserWiseConfirmCandidate(state) {
    return state.user_wise_candidate;
  },
  getIncourseData(state) {
    return state.incourse_data;
  },
  getIncourseCandidatesList(state) {
    return state.incourse_candidates_list;
  },
  getIncourseMarksList(state) {
    return state.incourse_marks_list;
  },
};
const mutations = {
  [SET_DATA_ENTRY_DETAILS](state, data) {
    return (state.data_entry_details = data);
  },
  [UNSET_DATA_ENTRY_DETAILS](state) {
    return (state.data_entry_details = {});
  },
  [SET_COLLEGE_USER_WISE_CANDIDATE](state, data) {
    return (state.user_wise_candidate = data);
  },
  [UNSET_COLLEGE_USER_WISE_CANDIDATE](state) {
    return (state.user_wise_candidate = {});
  },
  [GET_INCOURSE_DATA](state, data) {
    return (state.incourse_data = data);
  },
  [UNSET_GET_INCOURSE_DATA](state, data) {
    return (state.incourse_data = []);
  },
  [GET_INCOURSE_CANDIDATES_LIST](state, data) {
    return (state.incourse_candidates_list = data);
  },
  [GET_INCOURSE_MARKS_LIST](state, data) {
    return (state.incourse_marks_list = data);
  },
  // [UNSET_DATA_ENTRY_SCHEMA](state) {
  //     return state.dataEntrySchema = {
  //         reg_no: null
  //     }
  // }
};
const actions = {
  searchIncourseData({ commit }, searchParam) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", { color: "primary" });
      Axios.get(getIncourseData, { params: searchParam })
        .then((response) => {
          commit("UNSET_LOADING");
          const result = response.data.data;
          console.log("DA... : ", response.data.data);

          if (response.data.status === "success") {
            commit("GET_INCOURSE_DATA", result);
            resolve(result);
          } else {
            commit("SET_SNACKBAR", {
              msg: response.data.message || "Submission failed",
              color: "red",
            });
            reject(new Error(response.data.message || "Submission failed"));
          }
        })
        .catch((error) => {
          commit("UNSET_LOADING");
          const errorMessage =
            (error.response && error.response.data && error.response.data.message) ||
            error.message ||
            "Server error";
          commit("SET_SNACKBAR", { msg: errorMessage, color: "red" });
          reject(new Error(errorMessage));
        });
    });
  },

  resetIncourseData({ commit }) {
    commit("UNSET_GET_INCOURSE_DATA");
  },

  fetchIncourseCandidatesList({ commit }, searchParam) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", { color: "primary" });
      const config = {
        params: searchParam,
      };
      if (
        searchParam.display_type === "export_pdf" ||
        searchParam.display_type === "export_xl"
      ) {
        config.responseType = "blob";
      }
      Axios.get(getIncourseCandidatesList, config)
        .then(function (response) {
          commit("UNSET_LOADING");
          if (!searchParam.display_type) {
            const result = response.data.data;
            commit("GET_INCOURSE_CANDIDATES_LIST", result);
            resolve(response.data);
          }
          if (searchParam.display_type === "export_pdf") {
            const contentType = response.headers["content-type"];
            if (contentType !== "application/pdf") {
              const reader = new FileReader();
              reader.onload = () => {
                const text = reader.result;
                const parsed = JSON.parse(text);
                commit("SET_SNACKBAR", {
                  msg: parsed.message || "Unexpected response",
                  color: "red",
                });
                reject();
              };
              reader.readAsText(response.data);
              return;
            }
            resolve(response.data);
            const url =
              window.URL.createObjectURL(
                new Blob([response.data])
              );
            const link =
              document.createElement("a");
            link.href = url;
            if (searchParam.confirm_status == 1) {

              link.download =
                "incourse_marks_" +
                searchParam.exam_code +
                "_" +
                searchParam.exam_year +
                "_" +
                searchParam.college_code +
                "_" +
                searchParam.subject_code +
                ".pdf";
            } else {
              link.download =
                "incourse_candidates_" +
                searchParam.exam_code +
                "_" +
                searchParam.exam_year +
                "_" +
                searchParam.college_code +
                "_" +
                searchParam.subject_code +
                ".pdf";
            }
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
            return;
          }
          if (searchParam.display_type === "export_xl") {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement("a");
            link.href = url;
            if (searchParam.confirm_status == 1 && searchParam.display_type == "export_xl") {
              link.download =
                "incourse_marks_" +
                searchParam.exam_code +
                "_" +
                searchParam.exam_year +
                "_" +
                searchParam.college_code +
                "_" +
                searchParam.subject_code +
                ".xlsx";
            } else {
              link.download =
                "incourse_candidates_" +
                searchParam.exam_code +
                "_" +
                searchParam.exam_year +
                "_" +
                searchParam.college_code +
                "_" +
                searchParam.subject_code +
                ".xlsx";
            }
            document.body.appendChild(link);
            link.click();
            link.remove();
            resolve(response);
            return;
          }
        })
        .catch(function (error) {
          commit("UNSET_LOADING");
          var msg =
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            "Server error";
          commit("SET_SNACKBAR", {
            msg: msg,
            color: "red",
          });
          reject(error);
        });
    });

  },

  fetchIncourseMarksList({ commit }, searchParam) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", {
        color: "primary",
      });
      Axios.get(getIncourseMarksList, {
        params: searchParam,
      })
        .then(function (response) {
          commit("UNSET_LOADING");
          var result = response.data.data;
          commit("GET_INCOURSE_MARKS_LIST", result);
          resolve(response.data);
        })
        .catch(function (error) {
          commit("UNSET_LOADING");
          reject(response.data.meta);
        });
    });
  },


  submitIncourseMarks: ({ commit }, payload) => {
    commit("SET_LOADING", {
      color: "primary"
    });

    return new Promise((resolve, reject) => {
      Axios.post(submitIncoursebyCu, payload)

        .then(response => {
          if (response.data.status == 'success') {
            commit("UNSET_GET_INCOURSE_DATA");
            commit("SET_SNACKBAR", {
              msg: response.data.message || "Marks submitted successfully",
              color: "green"
            });
            resolve(response);
          } else {
            commit("SET_SNACKBAR", {
              msg: response.data.message || "Submission failed",
              color: "red"
            });
            reject(new Error(response.data.message || "Submission failed"));
          }
        })

        .catch(error => {

          let msg = "Submission failed";

          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            msg = error.response.data.message;
          }

          commit("SET_SNACKBAR", {
            msg: msg,
            color: "red"
          });

          commit("SET_RETURN_MESSAGE", msg);

          reject(error);
        })

        .finally(() => {
          commit("UNSET_LOADING");
        });
    });
  },


  cancelIncourseCandidatesMarks({ commit }, searchParam) {
    return new Promise((resolve, reject) => {

      commit("SET_LOADING", { color: "primary" });

      Axios.get(cancelIncourseSubmissionbyCu, {
        params: searchParam,
      })

        .then(function (response) {

          commit("UNSET_LOADING");

          if (response.data.status === "success") {

            commit("SET_SNACKBAR", {
              msg: response.data.message || "Marks have been cancelled successfully",
              color: "green"
            });

            resolve(response.data);

          } else {

            commit("SET_SNACKBAR", {
              msg: response.data.message || "Process failed",
              color: "red"
            });

            reject(new Error(response.data.message || "Process failed"));
          }

        })

        .catch(function (error) {

          commit("UNSET_LOADING");

          var msg =
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            "Server error";

          commit("SET_SNACKBAR", {
            msg: msg,
            color: "red"
          });

          reject(error);

        });

    });
  },


  fetchDataEntryDetails: ({ commit, state }) => {
    let self = this;
    commit("SET_LOADING", {
      color: "primary"
    });
    commit("UNSET_DATA_ENTRY_DETAILS");
    return new Promise((resolve, reject) => {
      Axios.post(collegeUserFFShowUrl, state.dataEntrySchema)
        .then(response => {
          commit("SET_DATA_ENTRY_DETAILS", response.data.data);
          // commit("UNSET_DATA_ENTRY_SCHEMA");
        })
        .catch(error => {
          commit("UNSET_DATA_ENTRY_DETAILS");

          if (
            error.response.status != 401 &&
            error.response.statusText != "Unauthorized"
          ) {
            commit("SET_SNACKBAR", {
              msg: error.response.data.message,
              color: "red"
            });
            commit("SET_RETURN_MESSAGE", error.response.data.message);
          }
          reject(error);
        })
        .then(always => {
          commit("UNSET_LOADING");
        });
    });
  },
  ffConfirmByCollegeUser({ commit, state }) {
    commit("SET_LOADING", {
      color: "primary"
    });
    var params = new URLSearchParams();
    let url = ffConfirmByCollegeUserUrl;
    return new Promise((resolve, reject) => {
      Axios.post(url, state.data_entry_details)
        .then(response => {
          if (response.data.code == 200) {
            commit("SET_SNACKBAR", {
              msg: saveMsg,
              color: "green"
            });
            resolve();
          } else {
            commit("SET_SNACKBAR", {
              msg: failedMsg,
              color: "red"
            });
            reject();
          }
        })
        .catch(error => {
          // console.log(error);
          commit("SET_SNACKBAR", {
            msg: failedMsg,
            color: "red"
          });
          reject();
        })
        .then(always => {
          commit("UNSET_LOADING");
        });
    });
  },
  cancelConfirmation({ commit, state }) {
    commit("SET_LOADING", {
      color: "primary"
    });
    var params = new URLSearchParams();
    // Object.assign(params, state.dataEntrySchema)
    // params.append("reg_no", state.dataEntrySchema.reg_no);
    // console.log(params)
    let url = cancelConfirmationUrl;
    Axios.post(url, state.dataEntrySchema)
      .then(response => {
        commit("SET_SNACKBAR", {
          msg: response.data.message,
          color: "green"
        });
      })
      .catch(error => {
        if (
          error.response.status != 401 &&
          error.response.statusText != "Unauthorized"
        ) {
          commit("SET_SNACKBAR", {
            msg: error.response.data.message,
            color: "red"
          });
          commit("SET_RETURN_MESSAGE", error.response.data.message);
        }
        reject(error);
      })
      .then(always => {
        commit("UNSET_LOADING");
      });
  },
  cancelApplication({ commit, state }) {
    commit("SET_LOADING", {
      color: "primary"
    });
    var params = new URLSearchParams();
    // Object.assign(params, state.dataEntrySchema)
    params.append("reg_no", state.dataEntrySchema.reg_no);
    // console.log(params)
    let url = cancelApplicationUrl;
    Axios.post(url, state.dataEntrySchema)
      .then(response => {
        commit("SET_SNACKBAR", {
          msg: response.data.message,
          color: "green"
        });
      })
      .catch(error => {
        if (
          error.response.status != 401 &&
          error.response.statusText != "Unauthorized"
        ) {
          commit("SET_SNACKBAR", {
            msg: error.response.data.message,
            color: "red"
          });
          commit("SET_RETURN_MESSAGE", error.response.data.message);
        }
        reject(error);
      })
      .then(always => {
        commit("UNSET_LOADING");
      });
  },
  getCollegeUserWiseConfirmCandidate({ commit, state }, data) {
    commit("SET_LOADING", {
      color: "primary"
    });
    var params = new URLSearchParams();
    return new Promise((resolve, reject) => {
      Axios.post(getCollegeUserWiseConfirmCandidateUrl, data)
        .then(response => {
          commit("SET_COLLEGE_USER_WISE_CANDIDATE", response.data.data);
          resolve(response.data);
        })
        .catch(error => {
          commit("UNSET_COLLEGE_USER_WISE_CANDIDATE");
          reject();
        })
        .then(always => {
          commit("UNSET_LOADING");
        });
    });
  },











































};
export default {
  state,
  getters,
  actions,
  mutations
};
